import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { withTranslation } from 'react-i18next';
import { default as SelectSearch } from 'react-select';
import { Input, MultiRadio } from 'shared/components';

import './SelectRosterExaminee.scss';

const setMultiRadioList = (roomDisabled, t) => {
  const radioElements = [];
  radioElements.push({
    label: t('irregularities.searchRoomRosterLabel'),
    key: uniqueId(),
    value: 'room',
    name: 'options',
    disabled: roomDisabled,
  });
  radioElements.push({
    label: t('irregularities.searchFullRosterLabel'),
    key: uniqueId(),
    value: 'full',
    name: 'options',
  });

  return radioElements;
};

const mapRegs = (regs, hideMatchIdFlag) =>
  regs.map((reg) => ({
    label: `${reg.lastName}, ${reg.firstName}`,
    value: {
      firstName: reg.firstName,
      lastName: reg.lastName,
      middleName: reg.middleName,
      matchId: hideMatchIdFlag ? undefined : reg.matchId,
      refRegId: reg.refRegId,
      regId: reg.id,
    },
  }));

class SelectRosterExaminee extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchRosterType: props.roomSelectedFlag ? 'room' : 'full',
    };

    this.onChangeRosterRegs = this.onChangeRosterRegs.bind(this);
  }

  onChangeRosterRegs(e) {
    this.setState({
      searchRosterType: e.target.value,
    });
  }

  render() {
    const { searchRosterType } = this.state;
    const {
      roomRegsOptions,
      eventRegsOptions,
      disabledRoomRosters,
      selectedExaminee,
      errors,
      selectLabel,
      matchIdMessage,
      hideMatchIdFlag,
    } = this.props;

    const examineeOptions = searchRosterType === 'room' ? roomRegsOptions : eventRegsOptions;

    return (
      <div className="select-examinee-container">
        <MultiRadio
          onChange={this.onChangeRosterRegs}
          checkedValue={searchRosterType}
          radioList={setMultiRadioList(disabledRoomRosters, this.props.t)}
        />
        <div className="examinee-details">
          <div className="select-component">
            <div>
              <label
                className={` pt-2 fw-bold ${
                  errors && errors.selectedExaminee ? 'label-error' : ''
                }`}
                htmlFor="firstName">
                {this.props.t(selectLabel)}
              </label>
            </div>
            <SelectSearch
              className={`select-examinee ${
                errors && errors.selectedExaminee ? 'error-select' : ''
              }`}
              classNamePrefix="select-examinee"
              options={mapRegs(examineeOptions, hideMatchIdFlag)}
              value={selectedExaminee}
              name="selectExaminee"
              onChange={this.props.onSelectExaminee}
              isClearable
            />
            {Array.isArray(errors?.selectedExaminee) &&
              errors.selectedExaminee.map((error) => (
                <p className="text-error font-size-12 mb-0" key={error}>
                  {this.props.t(error)}
                </p>
              ))}
          </div>
          {!hideMatchIdFlag && (
            <Input
              type="text"
              name="matchId"
              value={selectedExaminee ? selectedExaminee.value.matchId : ''}
              onChange={() => {}}
              infoText={this.props.t(matchIdMessage)}
              label={this.props.t('irregularities.matchIDLabel')}
              disabled
            />
          )}
        </div>
      </div>
    );
  }
}

SelectRosterExaminee.propTypes = {
  selectedExaminee: PropTypes.shape({}),
  disabledRoomRosters: PropTypes.bool,
  roomRegsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  eventRegsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onSelectExaminee: PropTypes.func.isRequired,
  roomSelectedFlag: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

SelectRosterExaminee.defaultProps = {
  disabledRoomRosters: false,
};

export default withTranslation()(SelectRosterExaminee);
